import { TaskType } from '../types';

const TWEET_TEMPLATES: Partial<Record<TaskType, string>> = {
  // Daily share results
  [TaskType.TWEET_RESULT]: `The fireplace is roaring. 🔥 Just cleared [X] junk tokens and invested [Y] points for @junkfun_ lucky draw.

2026 is about focus.

#JunkFunNY2026`,

  // Reply to @junkfun_ tweets - No template, users write their own reply
  // [TaskType.REPLY_PROMPT]: removed to encourage organic replies

  // Retweet user content
  [TaskType.RT_USER_CONTENT]: `Sharing the junk-burning love! 🔥

Check out my fellow burners @junkfun_ #JunkFunNY2026`,

  // Weekly progress thread
  [TaskType.PROGRESS_THREAD]: `🧵 My @junkfun_ Weekly Recap

This week I:
✅ Burned [X] junk tokens
✅ Earned [Y] points
✅ Kept my [Z]-day streak going

2026 is about focus.

#JunkFunNY2026`,

  // Meme creation
  [TaskType.MEME_CREATION]: `[Your meme here]

🔥 Burning junk has never been this fun!

#JunkFunNY2026 #JunkFunMeme @junkfun_`,

  // Viral challenge
  [TaskType.VIRAL_CHALLENGE]: `🔥 The Ultimate Junk Burn Challenge 🔥

I'm going all in on @junkfun_ with [X] points!

Who can beat my score?

#JunkFunNY2026`,

  // Thread series
  [TaskType.THREAD_SERIES]: `🧵 Why I'm betting on @junkfun_ in 2026

1/ Everyone's wallet is full of worthless tokens. @junkfun_ lets you turn that digital clutter into something valuable...

#JunkFunNY2026`,

  // Twitter follow task
  [TaskType.TWITTER_FOLLOW]: `Just followed @junkfun_ and joined the New Year Campaign! 🔥

Burning junk tokens for a chance to win prizes.

#JunkFunNY2026`,

  // Like, tag & retweet
  [TaskType.TWITTER_LIKE_RT]: `I'm in! Joined the @junkfun_ New Year Campaign 🔥

Tag your friends who need to clean up their wallets!

#JunkFunNY2026`,
};

export function getTweetTemplate(taskType: TaskType): string | null {
  return TWEET_TEMPLATES[taskType] ?? null;
}

export function generateTwitterIntentUrl(tweetText: string): string {
  const encodedText = encodeURIComponent(tweetText);
  return `https://twitter.com/intent/tweet?text=${encodedText}`;
}

export function openTwitterIntent(tweetText: string): void {
  const url = generateTwitterIntentUrl(tweetText);
  window.open(url, '_blank', 'width=550,height=420');
}

function formatSolAmountForTweet(sol: number): string {
  // Keep it human-friendly for exact prize amounts (2, 1, 0.5, 0.1, etc.)
  // e.g. 2 -> "2", 0.5 -> "0.5", 0.1 -> "0.1"
  return sol.toFixed(4).replace(/\.?0+$/, '');
}

/**
 * New Year Campaign (NY2026) winner claim tweet.
 *
 * Note:
 * - We append `junk.fun/new-year-campaign` + required mentions to stay compatible
 *   with the existing lottery tweet verification checks.
 */
export function generateNewYearClaimTweetText(prizeSol: number): string {
  const x = formatSolAmountForTweet(prizeSol);

  return `I just turned my digital TRASH into a bag of SOL! 🎰🔥
I’m officially claiming ${x} SOL from the @junkfun_ New Year Lucky Prize Pool.
Luck was on my side today. Who else is cashing out their lottery tickets?! 🎟️💰
#JunkFunNY2026

junk.fun/new-year-campaign
@mantanetwork @bonk_inu`;
}

/**
 * New Year Campaign (NY2026) contribution payout claim tweet (14 SOL pool share).
 *
 * Used for users who did NOT win the Lucky Prize Pool draw but still earned a
 * pro‑rata payout from the Contribution Prize Pool.
 *
 * Note:
 * - We append `junk.fun/new-year-campaign` + required mentions to stay compatible
 *   with the existing lottery tweet verification checks.
 */
export function generateNewYearContributionClaimTweetText(
  prizeSol: number,
  userRank: number | null,
): string {
  const x = formatSolAmountForTweet(prizeSol);
  const rankText =
    userRank && userRank > 0 ? `I’m among the top ${userRank} contributors.` : `I’m among the top contributors.`;

  return `The grind doesn't stop, and it paid off. 🦝🛠️
Just claimed ${x} SOL from the @junkfun_ Contribution Prize Pool! ${rankText}
My wallet is clean, my 2026 is fueled, and the leaderboard doesn't lie. Are you on it? 📈🥇

junk.fun/new-year-campaign
@mantanetwork @bonk_inu`;
}
